angular.module('unica_invitation_transfer_event.invitation_transfer_event_services')

.factory('InvitationTransferEventDeleteService', function ($http, getBaseApiURL) {

	var invitationTransferEventDeleteService = {};

	invitationTransferEventDeleteService.delete = function (invitationTransferEventId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/invitation-transfer-event/delete/' + invitationTransferEventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	invitationTransferEventDeleteService.erase = function (eventId) {
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/invitation-transfer-event/delete-all/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});

	};

	return invitationTransferEventDeleteService;
});